import React from "react";
import { FieldBox } from "../../containers/field/FieldBox";

export const FieldPage = () => {
  return (
    <div>
      <FieldBox />
    </div>
  );
};
